var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
export var TRANSITION_DURATION = 180;
export var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  overflow: ", ";\n"], ["\n  overflow: ", ";\n"])), function (_a) {
    var status = _a.status;
    return (status === 'open' ? 'visible' : 'hidden');
});
export var Head = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject([""], [""])));
export var Drawer = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  position: relative;\n  height: ", ";\n  overflow: ", ";\n  transition: ", ";\n"], ["\n  position: relative;\n  height: ", ";\n  overflow: ", ";\n  transition: ",
    ";\n"])), function (_a) {
    var $height = _a.$height;
    return $height + "px";
}, function (_a) {
    var status = _a.status;
    return (status === 'open' ? 'visible' : 'hidden');
}, function (_a) {
    var status = _a.status;
    return status === 'open' ? '' : "height " + TRANSITION_DURATION + "ms ease-out;";
});
export var Content = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n"], ["\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n"])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=Accordion.styles.js.map